import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../init';
import { Dictionaries } from 'src/pages/SignInPage/_BLL/types';

export const useGetDictionaries = (): Dictionaries | null => {
	const res = useLiveQuery(() => db.dictionaries.toArray());
	const entries = res?.map(res => [res.name, res.value]);
	return entries ? Object.fromEntries(entries) : null;
};
